__turbopack_context__.v({
  "description": "styles-module__YYjrwa__description",
  "description-collapsed": "styles-module__YYjrwa__description-collapsed",
});
